"use client";

import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import clsx from "clsx";
import { useState, useEffect } from "react";
import SharedAmenities from "../shared-amenities";
import Autoplay from "embla-carousel-autoplay";
import LazyImage from "@/components/LazyImage";

export interface AmenitiesProps {
  title: string;
  description: string;
  facility: {
    id: string;
    label: string;
    is_new: boolean;
    icon: string;
  }[];
  facility_thumbnail: {
    id: string;
    label: string;
    image: string;
  }[];
}

export default function Amenities(props: AmenitiesProps) {
  const [api, setApi] = useState<CarouselApi>();

  const [activeCarousel, setActiveCarousel] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }

    setActiveCarousel(api.selectedScrollSnap());

    api.on("select", () => {
      setActiveCarousel(api.selectedScrollSnap());
    });
  }, [api]);

  return (
    <>
      <div className="bg-coffebrown py-10 xl:py-32">
        <div className="w-full xl:max-w-screen-xl mx-auto px-12 xl:px-0">
          <SharedAmenities
            title={props.title}
            description={props.description}
            facility={props.facility}
          />
        </div>
      </div>
      <div>
        {Array.isArray(props.facility_thumbnail) && props.facility_thumbnail.length > 0 ? (
          <Carousel
            opts={{ loop: true }}
            plugins={[
              Autoplay({
                delay: 5000,
              }),
            ]}
            className="w-full"
            setApi={setApi}
          >
            <CarouselContent>
              {props.facility_thumbnail.map((facility) => {
                return (
                  <CarouselItem key={facility.id} className="pl-0">
                    <LazyImage
                      src={facility.image}
                      className="w-full h-full object-cover max-h-4xl xl:h-[calc(100vh-var(--navbar-height))]"
                      rootMargin="50px 0px 0px 0px"
                    />
                  </CarouselItem>
                );
              })}
            </CarouselContent>

            <div className="absolute bottom-8 left-1/2 xl:left-32 -translate-x-1/2 xl:translate-x-0">
              <p className="font-semibold text-white text-[8px] xl:text-2xl">
                {props.facility_thumbnail[activeCarousel]?.label ?? ""}
              </p>
            </div>

            <div className="hidden xl:inline-flex absolute bottom-4 xl:bottom-8 left-1/2 -translate-1/2 z-10 space-x-2">
              {props.facility_thumbnail.map((_, index) => {
                return (
                  <button
                    key={index}
                    onClick={() => api?.scrollTo(index, true)}
                    className={clsx(
                      "w-4 h-4 bg-white rounded-full cursor-pointer",
                      {
                        "w-12": activeCarousel === index,
                      }
                    )}
                  ></button>
                );
              })}
            </div>

            <CarouselPrevious className="flex xl:hidden size-5  left-5 bg-transparent cursor-pointer text-white z-10 border-2 !border-white" />
            <CarouselNext className="flex xl:hidden size-5  right-5 bg-transparent cursor-pointer text-white z-10 border-2 border-white" />
          </Carousel>
        ) : null}
      </div>
    </>
  );
}
